import { parseData } from 'src/core/classes/helpers'

const DEFAULT_FORMS = {
  attachments: {
    id: 553,
    code: 'Attachments',
  },
  dropdowns: {
    id: 97,
    code: 'Dropdown',
  },
  orgChart: {
    id: 495,
    code: 'OrgChart',
  },
  userRuleExceptions: {
    id: 1290,
    code: 'appuserruleexceptions-1290',
  },
  appUsersApps: {
    id: 495,
    code: 'AppUsersApps',
  },
  cleverAppHeader: {
    id: 685,
    code: '685_header-data',
  },
  cleverApps: {
    id: 685,
    code: '685_apps_info',
  },
  proceduresForm: {
    id: 550,
  },
  countriesList: {
    id: 74,
    code: 'CountriesList',
  },
  errorLogs: {
    id: 604,
    code: '604_error_logs',
  },
  assistantIntegration: {
    key: 'assistantIntegration',
    id: 1942,
    formId: 1942,
    code: 'ai-assistant-requestitemintegration-1942',
  },
}

const newFormsData = parseData<typeof DEFAULT_FORMS>(import.meta.env.VITE_CORE_FORMS)

export const CORE_FORM = { ...DEFAULT_FORMS, ...newFormsData } as typeof DEFAULT_FORMS
